import { JobTypeResponse } from '../../interfaces/jobs';
import { marketplaceApi } from '../../services/Api';

export const getJobTypes = async (): Promise<JobTypeResponse> => {
  const response = await marketplaceApi.get<JobTypeResponse>('/jobs/jobTypes');

  return response.data;
};
